
import log from 'loglevel';
import { getAuthenticatedClient } from "../auth/authClient";

var graph = require('@microsoft/microsoft-graph-client');

export const getRepliesAndDispatch = async (teamId, channelId, messageId, accessToken, dispatch) =>{
       
  log.info(` getRepliesAndDispatch @ ReplyService`);
  log.debug(`getRepliesAndDispatch @ ReplyService accessToken: ${accessToken}`);
  
  const repliesUrl = `/teams/${teamId}/channels/${channelId}/messages/${messageId}/replies`; //MESSAGES_URL;
     
  const client = getAuthenticatedClient(accessToken);    
    
    try {
    const res = await client
    .api(repliesUrl)
            .headers({
              "Content-Type" : "application/json;charset=UTF-8",
               "mode": "cors",
              "Access-Control-Allow-Origin" : '' 
            })
            .version('beta')
            .get((error, replies, rawResponse) => {

                  let someReplies =    replies.value.filter(reply =>{                         
                    if (reply.body.content.length > 0 ) return true;
                    return false;
                  });

                  let __items = [];
                  someReplies.forEach(reply => {
                    
                    let _reply = 
                    {
                      id :  reply.id,
                      date: reply.createdDateTime ? reply.createdDateTime : `not available`, 
                      text : `[Reply:] ${reply.body.content.trim().replace( /(<([^>]+)>)/ig, '')}`,
                      webUrl : reply.webUrl,
                      user : reply.from.user.displayName,
                      type : "Reply",
                      selected : true
                    };
                    
                    //addItem(_reply);              
                    __items.push(_reply);
                    }
                  );
                  const __itemsReversed = [...__items].reverse()  
                  dispatch({ type: "ADD_MESSAGES", payload: __itemsReversed });

            }//get
          )//get
        } catch (error) {
          log.error(`error / getRepliesAndDispatch @RepliesService ${JSON.stringify(error)}`);
      } finally {
          log.info(`finally / getRepliesAndDispatch @RepliesService`);
      }
}


// } catch (err) {
//            console.log('err'+ JSON.stringify(err));

// }


               // console.log('@getReplies >  selectedReplies+++ ' + JSON.stringify(replies)); 
              // console.log('@getReplies >  rawResponse+++ ' + JSON.stringify(rawResponse)); 
              // console.log('@getReplies >  error+++ ' + JSON.stringify(error)); 
              // console.log('++++++++++++++++++++++++')

                // if (replies) {
                  
                // let someReplies = [...replies.value];
                // if (replies.value.length > 0){
                //     someReplies = [replies.value[0],replies.value[1],replies.value[2]];
                // }       


                // //const  selectedMessages =   someMessages.value.map(message => {
                //     const  selectedReplies =   replies.value.map(reply => {
                //     let _reply = 
                //     {
                //        id :  reply.id,
                //        content : reply.body.content,
                //        webUrl : reply.webUrl,
                //        user : reply.from.user.displayName
                //     };
                //     addItem(_reply);
                //     return _reply;
                // });

                // console.log('----------------------------------')
                // console.log('@getReplies >  selectedReplies ' + JSON.stringify(selectedReplies));
                // console.log('----------------------------------')
                
                
                // selectedReplies.forEach(rpl => {
                  
                //   addItem(rpl);




                         // //const  selectedMessages =   someMessages.value.map(message => {
              //   const  selectedReplies =   replies.value.map(reply => {
              //     let _reply = 
              //     {
              //        id :  reply.id,
              //        content : reply.body.content,
              //        webUrl : reply.webUrl,
              //        user : reply.from.user.displayName
              //     };
              //     addItem(_reply);
              //     return _reply;
              // });
   
 // try{
    //console.log(`@getMessages >  teamId - ${teamId} , channelId - ${channelId}`);
    //https://graph.microsoft.com/beta/teams/{group-id-for-teams}/channels/{channel-id}/messages/{message-id}/replies/
    